// Saved views for Quality Operations.
// Built-in presets + user-saved views in localStorage.
// Group chips serialize as stable string keys ('practice', 'owner', 'measure', etc.)
// and resolve to entity-type IDs at runtime so views are portable across tenants.

const STORAGE_KEY = 'quality_ops_user_views_v1';
const LAST_VIEW_KEY = 'quality_ops_last_view_v1';

const ENTITY_TYPE_KEY_MAP = {
  practice: 'Practice',
};

export const BUILTIN_PRESETS = [
  {
    key: 'default',
    name: 'Default',
    state: {
      grain: 'work',
      groupChips: ['owner'],
      activeProgram: null,
      workTypeFilter: [],
      ownerFilter: [],
      statusFilter: [],
      routingTierFilter: [],
      engagementFilter: [],
      canCallOnly: true,
      overdueOnly: false,
      unassignedOnly: false,
      staleOnly: false,
      activeDatePreset: null,
      dateFrom: '',
      dateTo: '',
    },
  },
];

export function resolveGroupChip(key, entityTypes) {
  if (typeof key === 'number') return key;
  // String chips that don't depend on tenant entity types pass through.
  const passthrough = ['owner', 'work_type', 'measure', 'status', 'routing_tier', 'contract', 'payer', 'program'];
  if (passthrough.includes(key)) return key;
  const typeName = ENTITY_TYPE_KEY_MAP[key];
  if (!typeName) return null;
  const et = entityTypes.find(e => e.type_name === typeName);
  return et ? et.id : null;
}

export function serializeGroupChip(value, entityTypes) {
  if (typeof value === 'string') return value;
  const et = entityTypes.find(e => e.id === value);
  if (!et) return null;
  for (const [key, name] of Object.entries(ENTITY_TYPE_KEY_MAP)) {
    if (et.type_name === name) return key;
  }
  return null;
}

export function loadUserViews() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveUserViews(views) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
}

export function loadLastViewKey() {
  return localStorage.getItem(LAST_VIEW_KEY);
}

export function saveLastViewKey(key) {
  if (key) localStorage.setItem(LAST_VIEW_KEY, key);
  else localStorage.removeItem(LAST_VIEW_KEY);
}
